import React, { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useParams } from 'react-router-dom'
import styles from './InvoicePaymentPage.module.css'

const PaymentSuccessPage = () => {
  const { token } = useParams()
  const [status, setStatus] = useState(null)
  const [error, setError] = useState('')

  const loadStatus = useCallback(async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API}/payments/links/${encodeURIComponent(token)}/status`)
      setStatus(data)
      setError('')
    } catch (requestError) {
      setError(requestError?.response?.data?.message || 'Unable to verify the payment status.')
    }
  }, [token])

  useEffect(() => {
    loadStatus()
  }, [loadStatus])

  useEffect(() => {
    if (status?.state !== 'processing') return undefined
    const timer = setInterval(loadStatus, 5000)
    return () => clearInterval(timer)
  }, [loadStatus, status?.state])

  const isPaid = status?.state === 'paid'
  const isProcessing = status?.state === 'processing'
  const canRetry = status?.state === 'active'
  const isUnavailable = status && ['expired', 'revoked'].includes(status.state)
  const title = isPaid ? 'Payment received' : isProcessing ? 'Payment submitted' : canRetry ? 'Payment not completed' : isUnavailable ? 'Payment link unavailable' : 'Checking your payment'
  const message = isPaid
    ? 'Thank you. Your invoice has been updated and a receipt will be emailed by Wholesale USA.'
    : isProcessing
      ? 'Your ACH payment is processing. Bank payments can take several business days to settle; the invoice will update automatically when Stripe confirms it.'
      : canRetry
        ? (status.failureMessage || 'The payment was not completed. You can return to the invoice and try again while the link remains active.')
        : isUnavailable
          ? 'This payment link is no longer active. Please contact Wholesale USA if you need a new link.'
          : 'Please keep this page open while we verify the result with Stripe.'

  return (
    <main className={styles.paymentPage}>
      <div className={styles.successFrame}>
        <img src="/images/wholesale_shield.PNG" alt="Wholesale USA" className={styles.successLogo} />
        <section className={styles.successCard}>
          <div className={`${styles.successIcon} ${isProcessing ? styles.processingIcon : ''}`}>
            {isPaid ? '✓' : isProcessing ? '…' : canRetry ? '!' : '•'}
          </div>
          <span className={styles.eyebrow}>Wholesale USA</span>
          <h1>{error ? 'Unable to verify payment' : title}</h1>
          <p>{error || message}</p>
          {canRetry && <Link className={styles.primaryButtonLink} to={`/pay/${token}`}>Return to payment</Link>}
          {(isPaid || isProcessing) && <p className={styles.safeToClose}>You may safely close this page.</p>}
        </section>
      </div>
    </main>
  )
}

export default PaymentSuccessPage
